import { useEffect, useState } from 'react';
import {
  CalendarListExternalCalendar,
  CalendarListSchedular,
  ExternalCalendar,
  ExternalCalendarsRenameRequest,
  Schedular,
} from '../../../utils/types';
import CalendarListMenu from './CalendarListMenu';
import * as Sentry from '@sentry/nextjs';
import Image from 'next/image';
/* eslint-disable @typescript-eslint/no-unused-vars */

type CalendarListProps = {
  externalCalendars: CalendarListExternalCalendar[];
  setExternalCalendars: (calendars: CalendarListExternalCalendar[]) => void;
};

export default function CalendarList({
  externalCalendars,
  setExternalCalendars,
}: CalendarListProps) {
  const [menuOpenIndex, setMenuOpenIndex] = useState<number | null>(null);
  const [schedulars, setSchedulars] = useState<Schedular[]>([]);

  useEffect(() => {
    getSchedulars();
  }, []);

  async function deleteExternalCalendar(index: number) {
    try {
      const id: number = externalCalendars[index].id;

      const response = await fetch(`/api/user/externalCalendars/${id}/delete`);

      if (response.ok) {
        //show message telling user it was successful
        setExternalCalendars(externalCalendars.filter((_, i) => i !== index));
        alert('disconnected ' + externalCalendars[index].name);
      } else {
        //show message telling the user that it was unsuccessful
        alert('could not disconnected ' + externalCalendars[index].name);
      }
    } catch (error: any) {
      console.error('src/components/settings/account.tsx', error);
      Sentry.captureException(error);
    }
  }

  //display events - initial allow
  //default reserve - initial include

  async function getSchedulars() {
    const response = await fetch('/api/flexCals/getAll');
    const responseObject: Schedular[] = await response.json();
    setSchedulars(responseObject);
  }

  function getMenuSchedulars(index: number): CalendarListSchedular[] {
    return schedulars.map((schedular: Schedular) => ({
      id: schedular.lazyCalendarId,
      name: schedular.name,
      active: externalCalendars[index].excludedSchedulars.includes(
        schedular.lazyCalendarId
      ),
    }));
  }

  async function renameCalendar(index: number, newName: string) {
    function isNullOrWhiteSpace(input: string | null | undefined): boolean {
      return !input || input.trim().length === 0;
    }

    // Make sure the user does not rename the calendar to nothing or to spaces
    if (isNullOrWhiteSpace(newName)) return;

    const request: ExternalCalendarsRenameRequest = {
      externalCalendarId: externalCalendars[index].id,
      name: newName,
    };

    const response = await fetch('/api/user/externalCalendars/rename', {
      body: JSON.stringify(request),
      method: 'POST',
    });

    console.log(response);

    if (response.ok) {
      setExternalCalendars(
        externalCalendars.map(
          (calendar: CalendarListExternalCalendar, calendarIndex: number) =>
            calendarIndex !== index ? calendar : { ...calendar, name: newName }
        )
      );
    }
  }

  return (
    <ol className="overflow-y-auto">
      {externalCalendars.map((calendar, index) => (
        <li key={calendar.id} className="flex my-2">
          {menuOpenIndex === index && (
            <CalendarListMenu
              open={menuOpenIndex === index}
              close={() => setMenuOpenIndex(null)}
              initialShowOnSchedularPage={calendar.showOnSchedularPage}
              initialIncludeWithNewSchedulars={
                calendar.includeWithNewSchedulars
              }
              schedulars={getMenuSchedulars(index)}
              calendar={calendar}
              renameCalendar={(name: string) => renameCalendar(index, name)}
            />
          )}

          <button
            className="justify-between hover:bg-gray-200 hovor:shadow-xl flex flex-row rounded-xl border-4 border-confirmed-secondary py-1 px-3 pl-3 w-full"
            onClick={() => setMenuOpenIndex(index)}
          >
            <div className="text-left">
              <p className="font-bold text-black">{calendar.name}</p>
              <p className="text-blue-gray-600">{calendar.provider}</p>
            </div>
            <Image
              unoptimized
              className="object-contain"
              src="/images/settings.png"
              alt="settings"
              width={35}
              height={4}
            />
          </button>

          <button
            className="flex items-center justify-center hover:bg-gray-200 hovor:shadow-xl rounded-xl border-4 border-confirmed-secondary mx-2 px-1"
            onClick={() => deleteExternalCalendar(index)}
          >
            <Image
              unoptimized
              className="object-contain"
              src="/images/disconnect.png"
              alt="settings"
              width={60}
              height={60}
            />
          </button>
        </li>
      ))}
    </ol>
  );
}
